import { createMuiTheme } from '@material-ui/core/styles';

const pbMaterialTheme = createMuiTheme({
  palette: {
    primary: { main: '#0f6474' },
    secondary: { main: '#00b6bc', contrastText: '#fff' },
  },
  typography: {
    fontSize: 18,
    button: {
      textTransform: 'none',
      fontSize: 13,
    },
  },
});

export default pbMaterialTheme;
